import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";
import { TableProperties } from "../../../../shared/components/ui/Table/types";
import { useSelector } from "react-redux";
import { selectproductWarehousesRefreshTable } from "../../../../redux/selectors/productWarehouses.selectors";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import { refreshTableAddressesUser } from "../../../../redux";
import { saucesWarehousesService } from "../../../../shared/services";

const { confirm } = Modal;

export const useDeleteWerehouseSauce = () => {
  const dispatch = useAppDispatch();
  const [tableProps, setTableProps] = React.useState<TableProperties>();
  const isproductWarehousesRefreshTable= useSelector(
    selectproductWarehousesRefreshTable
  );
  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la Marca con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar marca" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar marca",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await saucesWarehousesService.remove(valId)
          .then((_res) => {
              notify.success(`Se ha borrado con éxito la el producto de la bodega con id:${valId}`);
              tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (isproductWarehousesRefreshTable) {
      tableProps?.refresh();
      dispatch(refreshTableAddressesUser(false));
    }
  }, [isproductWarehousesRefreshTable]);
  
  return {
    tableProps,
    showDeleteConfirm,
    setTableProps,
  };
};
